export const FeatureConstants = {
    ADHOC_PRINT_ENABLED: "ADHOC_PRINT_ENABLED",
    VIRTUAL_DEPART_DRIVER_ENABLED: "VIRTUAL_DEPART_DRIVER_ENABLED",
    DRIVER_PACKAGE_SUMMARY_TAB_ENABLED: "DRIVER_PACKAGE_SUMMARY_TAB_ENABLED",
    EWAY_BILL_TAB_ENABLED: "EWAY_BILL_TAB_ENABLED",
    VIRTUAL_DEPART_STORE_ENABLED: "VIRTUAL_DEPART_STORE_ENABLED"
}


// WEBPACK FOOTER //
// ./src/components/constants/FeatureConstants.js